var Flickity = require('flickity');

function FavoriteRow(el) {
	var t = this;

	t.slider = el.querySelector('[data-favorite-slider]');
	if ( t.slider && t.slider.childElementCount > 3 ) {
		var slider = new Flickity( t.slider, {
			cellAlign: 'center',
			contain: true,
			prevNextButtons: true,
			pageDots: false,
			wrapAround: true,
			arrowShape: {
				x0: 10,
				x1: 55, y1: 50,
				x2: 55, y2: 45,
				x3: 15
			}
		});
	}
}

module.exports = FavoriteRow;
